var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4086 7.60279L20.423 7.62777C20.4825 7.73048 20.5064 7.84399 20.4986 7.95406C20.4995 7.97045 20.4999 7.98693 20.4999 8.00351V20.416C20.4999 21.1578 19.8964 21.7613 19.1546 21.7613H4.84532C4.10352 21.7613 3.5 21.1578 3.5 20.416V8.04884C3.5 7.93057 3.52135 7.81722 3.5602 7.71233C3.57286 7.66647 3.59078 7.62132 3.61564 7.57816L6.37567 2.78991C6.57123 2.45081 6.93572 2.24023 7.32702 2.24023H16.6734C17.0641 2.24023 17.4283 2.45032 17.6239 2.7885L20.3397 7.48372C20.3655 7.52151 20.3886 7.56127 20.4086 7.60279ZM16.6468 3.38447H12.5917V7.07797H18.7832L16.6468 3.38447ZM11.4474 3.38447H7.35367L5.22465 7.07797H11.4474V3.38447ZM19.1546 20.6171C19.2655 20.6171 19.3557 20.5269 19.3557 20.416V8.22221H4.64424V20.416C4.64424 20.5269 4.73445 20.6171 4.84532 20.6171H19.1546ZM13.788 12.5355C14.0114 12.3121 14.3737 12.3121 14.5971 12.5355C14.8205 12.7589 14.8205 13.1212 14.5971 13.3446L11.6379 16.3037C11.5263 16.4155 11.3798 16.4714 11.2334 16.4714C11.087 16.4714 10.9406 16.4155 10.8289 16.3037L9.44195 14.9169C9.21852 14.6935 9.21852 14.3312 9.44195 14.1078C9.66537 13.8844 10.0277 13.8844 10.251 14.1078L11.2334 15.0901L13.788 12.5355Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/assigned.25b4655a3ce686d4eef4272b2c4aca4a.svg";
export { ForwardRef as ReactComponent };